import React from 'react';

const NotFoundPage = () => {
  return <div>도메인을 다시 확인해주세요!</div>;
};

export default NotFoundPage;
